<template>
    <div class="adjust-item-task-add">
        <el-dialog id="adjust-item-task-add-dialog-id"
                   :close-on-click-modal="false"
                   append-to-body
                   :visible.sync="isVisible"
                   class="frame-dialog"
                   title="添加"
                   top="5vh"
                   width="80%"
                   @close="close">
            <div>
                <!-- 弹框内容 -->
                <sieve-single-center v-if="isVisible"
                                     :QCO='QCO'
                                     ref="sieveSingleCenter" />
                <div class="page-module-btn">
                    <el-button type="primary"
                               @click="close">取 消</el-button>
                    <el-button type="primary"
                               @click="handleOk">添 加</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SieveSingleCenter from './sieveSingleCenter';

export default {
    name: 'train-adjust-task-add',
    components: { SieveSingleCenter },
    props: ['QCO'],
    data () {
        return {
            isVisible: false,
            initSearchInfo: {
                taskStatus: '0' // 默认显示 “待调度”，且不能修改
            }
        };
    },
    methods: {
        open () {
            this.isVisible = true;
        },
        close () {
            this.isVisible = false;
        },
        handleClose () {
            this._reject();
        },
        handleOk () {
            this.$emit('tasksToAdd', this.$refs.sieveSingleCenter.tlGetSelectedRows());
        }
    }
};
</script>
<style lang="less">
#adjust-item-task-add-dialog-id {
    .mPane3-back-up {
        .el-table {
            min-height: calc(~'100vh - 366px') !important;
            max-height: calc(~'100vh - 366px') !important;
        }
    }

    .page-module-btn {
        display: flex;
        justify-content: end;
        margin: 12px 10px 0 0;
    }

    .frame-dialog {
        .el-dialog {
            min-width: 1200px;
        }
    }
}
</style>
